import React from "react";
import {
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    Button,
    DialogActions,
} from "@mui/material";
import { Delete } from "@mui/icons-material";

const DeleteModal = ({
    title,
    subtitle,
    children,
    isOpen,
    handleClose,
    handleConfirm,
    cancelLabel = "Cancel",
    confirmLabel = "Delete",
}: any) => {
    return (
        <Dialog open={isOpen} onClose={handleClose}>
            <DialogTitle>
                <Delete sx={{ marginRight: 1, verticalAlign: "middle" }} />
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>{subtitle}</DialogContentText>
                {/* <Divider /> */}
                {children}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="error">
                    {cancelLabel}
                </Button>
                <Button onClick={handleConfirm} color="primary">
                    {confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteModal;
